module.exports = __webpack_public_path__ + "img/744.0dee7b13.jpg";